import { SettingsContainer } from 'src/containers/Settings/Settings';

export const Settings = () => <SettingsContainer />;
